import { objectKeys } from 'aem-libs-ts/src/utils/common/objectKeys'

export type MediaPrefix = 'sm'

export type PrefixedUnion<Prefix extends MediaPrefix, Union extends string> = `${Prefix}-${Union}`
export type PrefixedRecord<Prefix extends MediaPrefix, BaseRecord> = {
  [K in keyof BaseRecord as PrefixedUnion<Prefix, K & string>]: BaseRecord[K]
}

export const createMediaPropertyMap = <PropsUnion extends string, Prefix extends MediaPrefix>(
  baseMap: Record<PropsUnion, string>,
  prefix: Prefix
): Record<PrefixedUnion<Prefix, PropsUnion>, string> =>
  objectKeys(baseMap).reduce(
    (acc, key) => ({ ...acc, [`${prefix}-${key}`]: baseMap[key] }),
    {} as Record<PrefixedUnion<Prefix, PropsUnion>, string>
  )
